/* eslint-disable max-len */
// import { useCookies } from 'react-cookie'
// import { Cookies } from 'react-cookie'

const axios = require('axios')

// export const BASE_URL = 'https://panel.garnettalent.ir/api'
export const BASE_URL = 'https://panel.garnettalent.ir/api/beta'
export const IMAGE_BASE_URL = 'https://file.garnet.rahkar.local/'
export const FILE_BASE_URL = 'https://file.garnet.rahkar.local/'
export const TOKEN_FIELD_STORAGE = 'id_token'
export const TOKEN_VIDEO = 'video_token'

const axiosApiInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 60000, // timeout after one minute
})

axiosApiInstance.interceptors.request.use(
  async (config) => {
    const { headers = {} } = config
    // const token = localStorage.getItem(TOKEN_FIELD_STORAGE)
    // const [cookies] = useCookies([TOKEN_FIELD_STORAGE])

    // const token = cookies
    // const cookies = new Cookies()
    // const token = cookies.get(TOKEN_FIELD_STORAGE)
    const token = localStorage.getItem(TOKEN_FIELD_STORAGE)
    const extendedConfig = {
      url: config.url,
      headers: token ? {
        Authorization: `Bearer ${token}`,
        'Accept-Language': 'fa-IR',
        Accept: 'application/json',
        ...headers,
      } : {
        Accept: 'application/json',
        'Accept-Language': 'fa-IR',
        ...headers,
      },
    }
    return { ...config, ...extendedConfig }
  },
  (error) => {
    Promise.reject(error)
  },
)

axiosApiInstance.interceptors.response.use(
  async (response) => {
    return response
  },
  async (error) => {
    return Promise.reject(error)
  },
)

export default axiosApiInstance
